var map = {
	"./Step1.svg": 1046,
	"./Step2.svg": 1047,
	"./Step3.svg": 1048,
	"./calendar_1week.svg": 1626,
	"./calendar_2weeks.svg": 1627,
	"./calendar_date.svg": 1628,
	"./calendar_hour.svg": 1629,
	"./calendar_month.svg": 1630,
	"./calendar_question.svg": 1631,
	"./continue_brief.svg": 1038,
	"./copy_brief.svg": 1037,
	"./new_brief.svg": 1039
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 967;